import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { getAdminSchoolLayoutData } from "#/modules/admin/schools.functions";

// Admin school detail layout (portal's `_protected.admin.schools.$id`): loads docenten + school
// + invites once; the `overview` / `docenten` children read this via `getRouteApi(...)`.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/admin/schools/$id")({
  loader: ({ params }) => getAdminSchoolLayoutData({ data: { schoolId: params.id } }),
  component: () => <Outlet />,
  errorComponent: SchoolDetailError,
});

function SchoolDetailError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
